export enum ProductStatus {
  DESIGN = 'Design',
  LIVE = 'Live',
  UPDATED = 'Updated',
  CLOSED = 'Closed',
  REVIEW = 'Review',
  APPROVED = 'Approved',
  SCHEDULED = 'Scheduled',
}
